import React from 'react';
import SafeIcon from '../common/SafeIcon';
import TimestampInput from './TimestampInput';

function FieldLabel({ children }) {
  return (
    <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-[var(--text-secondary)] mb-2">
      {children}
    </label>
  );
}

const textInputClass =
  'w-full bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-xl py-3 px-4 text-sm text-[var(--text-main)] placeholder-[var(--text-secondary)]/50 focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green transition-all';

export default function ChapterEditorForm({
  rows,
  onChange,
  onAdd,
  onRemove,
  disabled = false,
  maxDurationSeconds = null,
}) {
  return (
    <div className="space-y-4">
      {rows.map((row, index) => (
        <div
          key={index}
          className="flex flex-col sm:flex-row gap-3 p-4 rounded-xl bg-[var(--bg-surface)] border border-[var(--border-subtle)]"
        >
          <div className="sm:w-28 flex-shrink-0">
            <FieldLabel>Tiempo</FieldLabel>
            <TimestampInput
              value={row.timestamp}
              onChange={(e) => onChange(index, 'timestamp', e.target.value)}
              disabled={disabled}
              aria-label={`Tiempo del capítulo ${index + 1}`}
            />
          </div>
          <div className="flex-1 min-w-0">
            <FieldLabel>Título</FieldLabel>
            <input
              type="text"
              value={row.title}
              onChange={(e) => onChange(index, 'title', e.target.value)}
              disabled={disabled}
              placeholder="Ej. Familia Latina"
              className={textInputClass}
            />
          </div>
          {rows.length > 1 && (
            <button
              type="button"
              onClick={() => onRemove(index)}
              disabled={disabled}
              className="self-end sm:self-center px-3 py-2 text-[var(--text-secondary)] hover:text-red-400"
              aria-label="Quitar capítulo"
            >
              <SafeIcon name="X" className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={onAdd}
        disabled={disabled}
        className="text-[10px] font-black uppercase tracking-widest text-brand-cyan hover:text-brand-green"
      >
        + Añadir capítulo
      </button>

      <p className="text-xs text-[var(--text-secondary)]">
        Usa formato mm:ss (ej. 02:24) o hh:mm:ss para videos de más de una hora.
        {maxDurationSeconds
          ? ` Duración del video: ${Math.floor(maxDurationSeconds / 60)}:${String(maxDurationSeconds % 60).padStart(2, '0')}.`
          : ''}
      </p>
    </div>
  );
}
